import React from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../../styles/theme/aistheme.css";
import "../../../styles/theme/sharedThemeOverride.css";

import { MenuItem } from "../../../globals/data/menuData/menuData";
import { changeLandingContentView } from "../../../globals/observables/landing/landingContentObservable";



const GeneralButtonStyle = {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    color: "black",
    height: "35px",
    marginTop: "auto",
    marginBottom: "auto",
    width: "35px",
    backgroundColor: "gray",
    maxHeight: "35px !Important",
    maxWidth: "35px  !Important",
    minHeight: "35px !Important",
    minWidth: "35px  !Important",
    padding: "0px"
  };
  
  
  const WrapperContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    background-color: blue;

    flex-bassis:100%;

    
    `
  );

  

  const DisplayLabelContainer = styled("div")(
    ({ theme }) => `
    color: #FFFFFF;
    
    margin-top: 0px;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
  
    font-family: 'poppins';
    font-weight: 400;
    font-size: calc(16px + (20 - 16) * ((100vw - 1366px) / (2560 - 1366)));
  
  
    `
  );
  


interface HeaderProps{
  
}


function ExamplePresenter2(props:HeaderProps){


   

    return (
        <WrapperContainer id="mennu block WrapperContainer">
            <DisplayLabelContainer>
              Example 2
            </DisplayLabelContainer>            
        </WrapperContainer>
        
    )
}


export default ExamplePresenter2;